<template>
  <v-data-table
    show-select
    v-model="localValue"
    :headers="headers"
    :items="produtos.content"
    class="elevation-1 mt-2"
    :loading="loading"
    :server-items-length="produtos.total"
    @update:options="updateOptions"
    :footer-props="footerOptions"
    no-data-text="Nenhum produto encontrado"
    loading-text="Carregando produtos..."
    :options="optionsList"
  >
    <template v-slot:item.produto.descricao="{ item }">
      <div>
        <div class="d-flex align-center">
          <px-produto-descricao v-if="item.produto"
                                show-codigo
                                :especificacao="item.especificacaoProduto"
                                :produto="item.produto"/>
          <span v-if="!item.produto">
            <px-span-tooltip top
                             :text="truncatedEspecificacao(item)"
                             :tooltip="item.especificacaoProduto"/>
          </span>
          <px-show-fornecedores-homologados-produto small
                                                    :produto="item.produto"/>
        </div>
        <px-show-large-text v-if="showEspecificacao && hasEspecificacaoAndProduto(item)"
                            small
                            text-class="caption"
                            :large-text="item.especificacaoProduto"/>
      </div>
    </template>
    <template v-slot:item.quantidade="{ item }">
      {{
        item.quantidade
          | number(getCurrencyFormat(item))
      }}
      {{ item.unidadeMedida.descricao }}
    </template>
    <template v-slot:item.responsavel.name="{ item }">
      <px-span-tooltip top
                       :text="usuarioTruncated(item)"
                       :tooltip="usuario(item)"/>
    </template>
    <template v-slot:item.createdIn="{ item }">
      {{item.createdIn | date}}
    </template>
    <template v-slot:item.urgencia="{ item }">
      <px-requisicao-urgencia :urgencia="item.requisicao.urgencia"/>
    </template>
    <template v-slot:item.requisicao.identificador="{ item }">
      <px-span-tooltip top
                       :text="identificadorLabel(item.requisicao.identificador)"
                       :tooltip="item.requisicao.identificador" />
      <v-btn icon small link target="_blank" :to="requisicaoLink(item)">
        <v-icon small>mdi-open-in-new</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import Vue from 'vue';
import { CasaDecimalUtils } from 'px-components';
import { mapGetters } from 'vuex';

export default {
  props: {
    value: Array,
    produtos: Object,
    loading: Boolean,
    optionsList: Object,
    onChangeOptions: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [10, 25, 50, 100, 200],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Produto',
          value: 'produto.descricao',
          sortable: false,
        },
        {
          text: 'Quantidade',
          value: 'quantidade',
          sortable: false,
        },
        {
          text: 'Solicitante',
          value: 'responsavel.name',
        },
        {
          text: 'Entrada em',
          value: 'createdIn',
          sortable: false,
        },
        {
          text: 'Urgência',
          value: 'urgencia',
          sortable: false,
        },
        {
          text: 'Solicitação',
          value: 'requisicao.identificador',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('requisicaoGeracao', ['showEspecificacao']),
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    getCurrencyFormat() {
      return (item) => {
        const casasDecimais = item.produto ? item.produto.casasDecimais : null;
        return CasaDecimalUtils.getCurrencyFormat(casasDecimais);
      };
    },
    identificadorLabel() {
      return identificador => Vue.filter('truncate')(identificador, 10);
    },
    truncatedEspecificacao() {
      return item => Vue.filter('truncate')(item.especificacaoProduto, 30);
    },
    hasEspecificacaoAndProduto() {
      return item => item.especificacaoProduto && item.produto && !item.produto.isGenerico;
    },
    requisicaoLink() {
      return item => `/requisicao/${item.requisicao.id}`;
    },
    usuarioTruncated() {
      return (item) => {
        const nome = item.requisicao.usuario ? item.requisicao.usuario.nome
          : item.requisicao.nomeResponsavel;
        return Vue.filter('truncate')(nome, 15);
      };
    },
    usuario() {
      return item => (item.requisicao.usuario ? item.requisicao.usuario.nome
        : item.requisicao.nomeResponsavel);
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
  },
};
</script>
